import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './ShowHasScreen.css';
import { useNavigate } from './Router';

const ShowHasScreen = () => {
  const [hasScreen, setHasScreen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkScreen = async () => {
      try {
        const screen = await sdk.models.Screen.getScreenWithIp({});
        if (screen !== null) {
          setHasScreen(true);
        }
      } catch (error) {
        console.error('Error checking for screen:', error);
      }
    };

    checkScreen();
  }, []);

  if (!hasScreen) return null;

  return (
    <div className="screen-alert-container">
      <div className="screen-alert-content">
        <div className="screen-icon">📺</div>
        <div className="screen-text-content">
          <h3 className="screen-title">Un écran public Peuple Qc est disponible !</h3>
          <p className="screen-description">
            Accédez au contenu exclusif sur notre écran public et découvrez l'expérience Peuple Qc.
          </p>
        </div>
      </div>
      <div 
        className="screen-action-btn"
        onClick={() => navigate('/withScreen')}
      >
        Voir l'écran
      </div>
    </div>
  );
};

export { ShowHasScreen };